import { render, staticRenderFns } from "./listing-box-location.vue?vue&type=template&id=3bd229dc&scoped=true&"
import script from "./listing-box-location.vue?vue&type=script&lang=js&"
export * from "./listing-box-location.vue?vue&type=script&lang=js&"
import style0 from "./listing-box-location.vue?vue&type=style&index=0&id=3bd229dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd229dc",
  null
  
)

export default component.exports